import { formatDateTime, parseDate } from '../../utils/dateUtils';
import { TextCell, TextCellProps } from './TextCell';

export const DateTimeCell = (
    props: TextCellProps & {
        dateString?: string;
    },
) => {
    const { dateString, ...rest } = props;
    return <TextCell value={dateString && formatDateTime(parseDate(dateString))} {...rest} />;
};
